<template>
  <CreateLaborerCertification
    v-if="modalEnabled"
    :vacancy-certification="vacancyCertification"
    :modal-enabled="modalEnabled"
    :laborer-certification="!!laborer && !!isCertified ? laborer.vacancyCertification : undefined"
    @onCreateLaborerCertificationModalSuccess="save"
    @onCreateLaborerCertificationModalCanceled="cancel"
  />

  <v-btn
    v-else
    :color="isCertified ? 'warning': 'info'"
    rounded
    outlined
    text
    small
    :title="isCertified ? `Соискатель добавлен в обучение ${certificationDate}.
     Нажмите для удаления` : 'Добавить соискателя в обучение'"
    @click="enableModal"
  >
    {{ isCertified ? 'Обучен' : 'Добавить' }}
    <v-icon v-if="isCertified">
      mdi-close
    </v-icon>
  </v-btn>
</template>
<script>

import CreateLaborerCertification from '@/views/vacancy/create-vacancy-certifiction-modal.vue'

export default {
  name: 'CreateLaborerCertificationDrawer',
  components: { CreateLaborerCertification },
  props: {
    vacancyCertification: {
      type: Object,
    },
    laborer: {
      type: Object,
    },
  },
  data () {
    return {
      modalEnabled: false,
    }
  },
  computed: {
    isCertified () {
      return this.laborer.vacancyCertification && this.laborer.vacancyCertification.id
    },
    certificationDate () {
      if (!this.isCertified) {
        return ''
      }
      return this.laborer.vacancyCertification.createdAt
    },
    canSave () {
      return true
    },
  },
  async created () {
  },
  methods: {
    enableModal () {
      this.modalEnabled = true
    },
    save (data) {
      this.$emit(
        'onCreateLaborerCertificationModalSuccess',
        { ...data, laborer: this.laborer }
      )
    },
    cancel () {
      this.modalEnabled = false
      this.$emit('onCreateLaborerCertificationModalCanceled')
    },
    disableModal () {
      this.modalEnabled = false
    },
  }
}
</script>
